import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Radio from '../../radio/Radio';
export const SelectOption = ({ data, isSelected, className, }) => {
    const { label, icon, disabled, value } = data;
    return (_jsx(OptionContainer, { className: className, children: _jsx(Radio, { checked: isSelected, title: `${label}`, icon: icon, testId: `option-${value}`, disabled: disabled }) }));
};
const OptionContainer = styled.div `
  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;

  margin: 0;
`;
//# sourceMappingURL=DefaultValues.js.map